import LoginOTP from '../../auth/components/otp/LoginOTP';

export default function OTPPage() {
    return <LoginOTP />;
}
